export default {"src":"/_next/static/media/v11.cc25e9a1.svg","height":130,"width":332};